import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";

import metrics from "@constants/metrics";
import CustomText from "@components/CustomText";
import CLAppLogo from "@assets/svg/Jrny/CLAppLogo";
import t from "@constants/localization";
import color from "../../../constants/color";

const PATH = "screens/CLFlow/components/Header";

const Header = ({}) => {
  return (
    <View style={styles.container}>
      <CLAppLogo />
      <CustomText variant="body_text_4" style={styles.text2}>
        {t(`${PATH}/form`)}
      </CustomText>
    </View>
  );
};

const styles = StyleSheet.create({
  text2: {
    marginLeft: 12,
  },
  container: {
    flexDirection: "row",
    paddingVertical: 16,
    paddingHorizontal: metrics.mainContainerPadding,
    backgroundColor: color.white,
    alignItems: "center",
    alignContent: "space-around",
    elevation: 10,
  },
});

export default Header;
